<template>
	<div class="flex flex-column">
		<div>
			<div class="font-24 flex items-center mb-8 head-bold">Avise-me quando chegar</div>
			<div class="text-regular mb-4">
				Preencha os campos abaixo para ser avisado quando a cotação do produto <b>{{ productData.descricao }}</b> estiver pronta.
			</div>
			<div v-if="!loadingRequest && !formSent && errorRequest === ''">
				<div class="relative w-full mb-4">
					<label class="inputlabel__ds">Nome completo<span class="requireddot">•</span></label>
					<input class="input__ds w-full" v-model="fullUserName" type="text" placeholder="Insira seu nome completo" @blur="$v.fullUserName.$touch" />
					<div class="danger font-12" v-if="$v.fullUserName.$error && $v.fullUserName.$invalid">Insira o seu nome completo</div>
				</div>
				<div class="relative w-full mb-4">
					<label class="inputlabel__ds">E-mail<span class="requireddot">•</span></label>
					<input class="input__ds w-full" v-model="userEmail" type="text" placeholder="Insira seu email" @blur="$v.userEmail.$touch" />
					<div class="danger font-12" v-if="$v.userEmail.$error && $v.userEmail.$invalid">Insira um e-mail válido</div>
				</div>
				<div class="relative w-full mb-4">
					<label class="inputlabel__ds">Telefone<span class="requireddot">•</span></label>
					<the-mask class="input__ds w-full" :mask="['(##) ####-####', '(##) #####-####']" placeholder="Informe o número de seu telefone" name="userPhone" maxlength="15" :masked="true" v-model="userPhone" v-model.trim="$v.userPhone.$model" />
					<div class="danger font-12" v-if="$v.userPhone.$error && $v.userPhone.$invalid">Insira um telefone válido</div>
				</div>
			</div>
			<div v-if="loadingRequest">
				<Loader />
			</div>

			<div v-if="!loadingRequest && formSent" class="text-center mb-4">
				<svg class="mx-auto my-4" width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path
						fill-rule="evenodd"
						clip-rule="evenodd"
						d="M36 72C16.1177 72 0 55.8823 0 36C0 16.1177 16.1177 0 36 0C55.8823 0 72 16.1177 72 36C72 45.5478 68.2072 54.7045 61.4558 61.4558C54.7045 68.2072 45.5478 72 36 72ZM36.0014 8.64196C20.8924 8.64196 8.64404 20.8903 8.64404 35.9994C8.64404 51.1084 20.8924 63.3568 36.0014 63.3568C51.1105 63.3568 63.3588 51.1084 63.3588 35.9994C63.3588 20.8903 51.1105 8.64196 36.0014 8.64196ZM19.3639 30.87L13.8405 37.5631L33.66 53.8736L58.743 28.7906L52.6347 22.6823L33.0751 42.1768L19.3639 30.87Z"
						fill="#029640"
					/>
				</svg>
				Sucesso ao salvar os dados
			</div>

			<div v-if="!loadingRequest && errorRequest !== ''" class="text-center head-regular mb-4">
				{{ errorRequest }}
			</div>
		</div>
		<div class="flex justify-end gap-4">
			<button class="btn__primary--outline" @click="$emit('triggerSolicitarCotacao')">Cancelar</button>
			<button class="btn__primary" @click="enviarCotacao()" :disabled="!isAllFormsValid || formSent || errorRequest !== ''">Enviar</button>
		</div>
		<div class="hidden">{{ isAllFormsValid }}</div>
	</div>
</template>

<script>
const API_B2C_BACKEND = process.env.API_B2C_BACKEND
const TOKEN_EPA = process.env.TOKEN_EPA
import { TheMask } from "vue-the-mask"
import { required, minLength, email, helpers } from "vuelidate/lib/validators"
import Loader from "@/components/Common/Loader.vue"
const validFullName = helpers.regex("validFullName", /^[a-zA-Z\u00C0-\u00FF ]+ [a-zA-Z\u00C0-\u00FF ]+$/)
export default {
	components: {
		Loader,
		TheMask,
	},
	props: {
		productData: {
			type: Object,
		},
	},
	data() {
		return {
			fullUserName: "",
			userEmail: "",
			userPhone: null,
			loadingRequest: false,
			formSent: false,
			errorRequest: "",
			successRequest: "",
		}
	},
	validations: {
		fullUserName: {
			required,
			validFullName,
		},
		userEmail: {
			required,
			email,
		},
		userPhone: {
			required,
			minLength: minLength(15),
		},
	},
	mounted() {
		if (this.usuario) {
			this.userEmail = this.usuario.email
			this.fullUserName = this.usuario.nome_razao
			this.userPhone = this.usuario.telefones[0].numero
		}
	},
	methods: {
		async enviarCotacao() {
			this.loadingRequest = true
			this.errorRequest = ""
			this.successRequest = ""
			let payload = {
				nome: this.fullUserName,
				email: this.userEmail,
				telefone: this.userPhone,
				id_produto: this.productData.id_produto,
				id_produto_variacao: this.productData.id_produto_variacao,
				origem: "aviseme",
			}

			try {
				const res = await this.$axios.post(API_B2C_BACKEND + `/produtos/wishlist?token=${TOKEN_EPA}`, payload)
				this.formSent = true
				this.successRequest = res.data.data
			} catch (error) {
				this.errorRequest = error.response.data.message
			}
			this.loadingRequest = false
		},
	},
	computed: {
		isAllFormsValid() {
			if (!this.$v.fullUserName.$invalid && !this.$v.userEmail.$invalid && !this.$v.userPhone.$invalid) {
				return true
			}
			return false
		},
		usuario() {
			let hasUser = localStorage.getItem("epeca-hub-b2c/usuario/email")
			if (hasUser) {
				let userData = this.$store.getters["usuario"]
				if (Object.keys(userData).length > 0) {
					return userData
				} else {
					return false
				}
			} else {
				return false
			}
		},
	},
}
</script>

<style lang="scss" scoped>
.input__ds {
	font-family: var(--text-regular);
	display: flex;
	flex-direction: row;
	align-items: center;
	padding: 22px 16px 8px 16px;
	background: #f1f1f1;
	border: 1px solid #c2c2c2;
	border-radius: 4px 4px 0px 0px;
	font-weight: 500;
	font-size: 16px;
	line-height: 19px;
	height: 49px;
	color: #000000;
	&.danger {
		border: 1px solid red;
		padding: 22px 16px 8px 16px;
	}
	&::placeholder {
		color: #c6cad1;
	}
}
.inputlabel__ds {
	position: absolute;
	top: 8px;
	font-weight: 500;
	font-size: 12px;
	line-height: 15px;
	color: #6f6f6f;
	left: 16px;
}
.danger {
	color: #c00;
	padding: 4px 16px 0;
}
.requireddot {
	color: #c00;
	font-size: 2em;
	line-height: 0;
	margin-left: 0.15em;
	vertical-align: sub;
}
</style>
